export class Email {
  static looksLikeMail(str) {
    return str.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/);
  }
}
